// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-item {
  display: flex;
  align-items: center;
}

.dropdown-item img {
  width: 60px;
  height: 60px;
  margin-right: 10px;
  filter: grayscale(100%);
}

.dropdown-item h3 {
  text-align: center;
  margin: 0;
  flex-grow: 1;
}

.icon {
  height: 80px;
  position: relative;
  margin: auto;
  display: grid;
}

.icon-tile {
  border: solid 1px #f0efef;
  border-radius: 8px;
  padding-top: 10px;
  margin-bottom: 10px;
}

.icon-tile-selected {
  border: solid 1px #f0efef;
  background-color: #f0efef;
  border-radius: 8px;
  padding-top: 10px;
  margin-bottom: 10px;
}

.icon-tile:hover {
  border: solid 1px #f0efef;
  border-radius: 8px;
  padding-top: 10px;
  margin-bottom: 10px;
  cursor: pointer;
  background-color: #f0efef;
}

.single-selected-icon .not-selected-cont {
  display: none;
}
.single-selected-icon .selected-cont .icon-tile,
.single-selected-icon .selected-cont .icon-tile:hover {
  border: none;
  background-color: transparent !important;
  pointer-events: none;
}

.change-icon-cont {
  display: flex;
  align-items: center;
}
@media screen and (max-width: 576px) {
  .change-icon-cont {
    justify-content: center !important;
  }
}
.change-icon-cont .change-icon-btn {
  min-width: 129px;
  height: 38px;
  border-radius: 4px;
  color: white;
  border: none;
  font-size: 14px;
  background-color: rgb(193, 193, 193);
  position: relative;
  top: -10px;
}
.change-icon-cont .change-icon-btn:hover {
  cursor: pointer;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
